import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  isLoading: false,
  error: null,
  success: null,
  requestedFieldId: null,
};

const plantsMeasurementsSlice = createSlice({
  name: "plantsMeasurements",
  initialState,
  reducers: {
    fetchPlantsMeasurementsStart(state, action) {
      state.isLoading = true;
      state.error = null;
      state.success = false;
      state.requestedFieldId = action.payload?.field_id || null;
      state.data = [];
    },
    fetchPlantsMeasurementsSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    fetchPlantsMeasurementsFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    },
  },
});

export const {
  fetchPlantsMeasurementsStart,
  fetchPlantsMeasurementsSuccess,
  fetchPlantsMeasurementsFailure,
} = plantsMeasurementsSlice.actions;
export default plantsMeasurementsSlice.reducer;
